import React, {useState, useEffect, Fragment} from 'react';
import './index.scss';

//assets
import WhyPurchase from "./sections/why-purchase";
import Catalog from "./sections/catalog";
import ConsultExpert from "./sections/consult-expert";
import {useDispatch, useSelector} from "react-redux";
import {getVehicleAdsPage} from "../../redux/actions";
import Loader from "../../components/common/loader";


const CarLead = (props) =>{

    // const [selected_tab, setSelectedTab] = useState(1);
    const vehicleAdsPage = useSelector(state => state.data.VehicleAdsPage);
    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(getVehicleAdsPage());
        // let itemsObj = {};

    },[]);



    return(
        <section className='car-lead'>
            {!vehicleAdsPage &&
                <Loader className="full-screen"/>
            }
            { vehicleAdsPage &&
                    <Fragment>
                        <WhyPurchase className="why-purchase-wrapper" />

                        <Catalog className="catalog-wrapper" />

                        <ConsultExpert className="consult-expert-wrapper"/>

                    </Fragment>
            }

        </section>
    );
};

export default CarLead;